export default "__VITE_ASSET__CvJXcRUm__"